export default "__VITE_ASSET__BjQddfLj__"